import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store/type'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseEventCreateBulkInboxPerNumber } from 'entities/Phone/api/types'

export const useEventInboxBulkCreationFinished = (
  handle: (data: IResponseEventCreateBulkInboxPerNumber) => void
) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.InboxBulkCreationFinished, handle), [])
}
